import history from '../history';
import {CONFIG,CONFIG_AUTH} from '../config';
import accountManagement from '../apis/accountManagement';
import authLogin from '../apis/authLogin';
import Cookies from 'js-cookie';
import {
    SIGN_IN,
    CEK_COOKIES,
    FETCH_ERROR,
    SIGN_OUT,
    FETCH_MENU,
    UPLOAD_FILE
} from './types';

const errorObj = {type: '', message: ''};

export const signIn = (formValues) => async (dispatch) => {
    const response = await authLogin.post(CONFIG_AUTH.AUTH_LOGIN, formValues,
        { auth: {
            username: 'eduprime',
            password: 'eduprime@123'
        }})
    .catch(function(error){
        errorObj.type = 'error';
        errorObj.message = error.message;
        dispatch({
            type: FETCH_ERROR,
            payload: errorObj
        })
        history.push('/login');
    });
    if(response){
        if (response.data.access_token != undefined && response.data.access_token != null) { 
            
            Cookies.remove('Set-Cookie');
            Cookies.set('Set-Cookie', response.data.access_token);
            dispatch({
                type: SIGN_IN,
                payload: response
            })
            errorObj.type = 'success';
            errorObj.message = 'success';
            dispatch({
                type: FETCH_ERROR,
                payload: errorObj
            })
            //history.push('/dashboard')
            window.location.assign('/dashboard');
        }else{
            errorObj.type = 'error';
            errorObj.message = 'Not authorized';
            dispatch({
                type: FETCH_ERROR,
                payload: errorObj
            })
            history.push('/login');
        }
    }
}

export const signOut = () => async (dispatch) => {
    Cookies.remove('Set-Cookie'); 
    Cookies.set('Set-Cookie', null);    
    
    errorObj.type = 'success';
    errorObj.message = 'User Logged Out...!!';
    dispatch({
        type: SIGN_OUT,
        payload: null
    })
    //history.push('/login');
    window.location.assign('/login');   
}

export const cekCookies = (fromPage = null) => async (dispatch) => {
    const response = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_COOKIES_CHECK).catch(function(error){
        Cookies.remove('Set-Cookie');
        errorObj.type = 'error';
        errorObj.message = error.message;
        dispatch({
            type: FETCH_ERROR,
            payload: errorObj
        })
    });
    let roleId = null;
    if(response){
        if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
            dispatch({
                type: CEK_COOKIES,
                payload: response.data
            })
            errorObj.type = 'success';
            errorObj.message = response.data.errorSchema.errorMessage;
            dispatch({
                type: FETCH_ERROR,
                payload: errorObj
            })
            roleId = response.data.data.idRole;
        }else{    
            Cookies.remove('Set-Cookie');
            errorObj.type = 'error';
            errorObj.message = 'Not authorized';
            dispatch({
                type: FETCH_ERROR,
                payload: errorObj
            })
        }
    }
    
    // Cookies.remove('Set-Cookie');
    // if(response){
    //     if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
    //         Cookies.set('Set-Cookie', response.data.cookie);
    //     }
    // }
    
    if(!response){        
        errorObj.type = 'error';
        errorObj.message = 'Not authorized';
        dispatch({
            type: FETCH_ERROR,
            payload: errorObj
        }) 
        if(fromPage !== 'login'){
            history.push('/login');
        }
    }else{        
        if(response.data.errorSchema.errorCode !== CONFIG.SUCCESS_ERROR_CODE){
            if(fromPage !== 'login'){
                history.push('/login');
            }
        }else{
            if(fromPage === 'login'){
                history.push('/dashboard');
            }
        }
    }

    if(response){
        if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
            const responseMenu = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_FETCH_MENU + roleId).catch(function(error){
                errorObj.type = 'error';
                errorObj.message = error.message;
                dispatch({
                    type: FETCH_ERROR,
                    payload: errorObj
                })
            });
            if(responseMenu){
                if(responseMenu.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                    dispatch({
                        type: FETCH_MENU,
                        payload: responseMenu.data
                    })
                }
            }
        }
    }
}

export const fetchMenu = (roleId) => async (dispatch) => {
    const response = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_FETCH_MENU + roleId).catch(function(error){
        errorObj.type = 'error';
        errorObj.message = error.message;
        dispatch({
            type: FETCH_ERROR,
            payload: errorObj
        })
    });
    if(response){
        if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
            dispatch({
                type: FETCH_MENU,
                payload: response.data
            })
        }
    }
}